import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  IconTick,
} from "@touchtech/web-baselayer-ui";

import { SignUpStatus } from "@is/constants";

import css from "./SignUpStatusModal.module.css";
import useManageSignUpStatusModal from "./hooks/useManageSignUpStatusModal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  status: SignUpStatus;
  errorMessage: string | null;
};

const SignUpStatusModal = ({
  isOpen,
  onClose,
  status,
  errorMessage,
}: Props) => {
  const { title, failedStatusText, t } = useManageSignUpStatusModal({
    status,
    errorMessage,
  });

  return (
    <ConfirmationModal isOpen={isOpen} onClose={onClose}>
      <div className={css.container}>
        <h1 className={classcat(["text-headline-5xl", css.title])}>{title}</h1>
        {status !== SignUpStatus.AccountCreated && (
          <span className={classcat(["text-label-xl", css.text])}>
            {failedStatusText}
          </span>
        )}
        <Button
          className={css.okButton}
          width="full"
          sizing="lg"
          onClick={onClose}
        >
          <IconTick />
          {t(`OK`)}
        </Button>
      </div>
    </ConfirmationModal>
  );
};

export default SignUpStatusModal;
